<div class="consumer-metadata mb-4">
  @if (consumerDataGroup) {
    @if (globalFields.length > 0) {
      <div class="metadata-section">
        <h3 class="mb-4">{{ ("metadata" | transloco) }}</h3>
        <div class="fields-grid">
          @for (field of globalFields; track trackByKey($index, field)) {
            <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field, group: consumerDataGroup }"></ng-container>
          }
        </div>
      </div>
    }

    @if (objectTypeFields.length > 0) {
      <div class="metadata-section mt-4">
        <h3 class="mb-2">Lernobjekt Metadaten</h3>
        <div class="fields-grid">
          @for (field of objectTypeFields; track trackByKey($index, field)) {
            <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field, group: consumerDataGroup }"></ng-container>
          }
        </div>
      </div>
    }

    <ng-template #pairedSelectionTree let-options let-value="value" let-control="control" let-parentName="parentName">
        <div class="selection-list pl-4 selection-list-bordered">
          @for (sel of value; track sel.name; let i = $index) {
              <div class="selected-item mt-2">
                  <div class="selection-item-row">
                      <strong>{{ sel.label || sel.name | transloco }}</strong>
                      @if (sel.secondaryLabel) {
                          <span class="secondary-label">({{ sel.secondaryLabel }})</span>
                      }
                      <button mat-icon-button color="warn" (click)="removeSelection(control, parentName, i)" class="delete-button-small">
                          <mat-icon>delete</mat-icon>
                      </button>
                  </div>

                  @if (getSrcOption(options, sel.name)?.subFieldConf?.length) {
                      <ng-container *ngTemplateOutlet="pairedSelectionTree; context: {
                        $implicit: getSrcOption(options, sel.name)?.subFieldConf,
                        value: getSubFieldConfSafe(sel),
                        control: control,
                        parentName: sel.name
                      }"></ng-container>
                  }
              </div>
          }

          @if (getAvailableOptions(options, value).length > 0) {
              <div class="mt-2">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <mat-label>{{ 'add_option' | transloco }}</mat-label>
                      <mat-select #selectElement (selectionChange)="addSelection(control, parentName, $event.value, selectElement)">
                          @for (opt of getAvailableOptions(options, value); track opt.name) {
                              <mat-option [value]="opt">{{ opt.label || opt.name | transloco }} @if (opt.secondaryLabel) { ({{ opt.secondaryLabel }}) }</mat-option>
                          }
                      </mat-select>
                  </mat-form-field>
              </div>
          }
      </div>
    </ng-template>

    <ng-template #selectionTree let-options let-value="value" let-control="control" let-parentName="parentName">
      <div class="selection-list pl-4 selection-list-bordered">
          @for (sel of value; track sel.name; let i = $index) {
              <div class="selected-item mt-2">
                  <div class="selection-item-row">
                      <strong>{{ sel.label || sel.name | transloco }}</strong>
                      <button mat-icon-button color="warn" (click)="removeSelection(control, parentName, i)" class="delete-button-small">
                          <mat-icon>delete</mat-icon>
                      </button>
                  </div>

                  @if (getSrcOption(options, sel.name)?.subFieldConf?.length) {
                      <ng-container *ngTemplateOutlet="selectionTree; context: {
                        $implicit: getSrcOption(options, sel.name)?.subFieldConf,
                        value: getSubFieldConfSafe(sel),
                        control: control,
                        parentName: sel.name
                      }"></ng-container>
                  }
              </div>
          }

          @if (getAvailableOptions(options, value).length > 0) {
              <div class="mt-2">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <mat-label>{{ 'add_option' | transloco }}</mat-label>
                      <mat-select #selectElement (selectionChange)="addSelection(control, parentName, $event.value, selectElement)">
                          @for (opt of getAvailableOptions(options, value); track opt.name) {
                              <mat-option [value]="opt">{{ opt.label || opt.name | transloco }}</mat-option>
                          }
                      </mat-select>
                  </mat-form-field>
              </div>
          }
      </div>
    </ng-template>

    <ng-template #fieldTemplate let-field let-group="group">
      <div class="field-item" [formGroup]="group">
          @switch (field.datatype) {
            
            @case (dataTypes.PairedSelection) {
              <div class="selection-section" [formGroup]="group">
                <h4 class="mb-2">{{ field.label || field.name | transloco }}</h4>

                @if (getUniqueSecondaryLabels(field.subFieldConf || []).length > 0) {
                  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="mb-2">
                    <mat-label>{{ 'filter_example' | transloco }}</mat-label>
                    <mat-select [formControl]="getSecondaryLabelFilterControl(field.name)" multiple>
                      @for (sl of getUniqueSecondaryLabels(field.subFieldConf || []); track sl) {
                        <mat-option [value]="sl">{{ sl }}</mat-option>
                      }
                    </mat-select>
                    @if (getSecondaryLabelFilterControl(field.name).value?.length) {
                      <button matSuffix mat-icon-button (click)="$event.stopPropagation(); getSecondaryLabelFilterControl(field.name).setValue(null)">
                        <mat-icon>close</mat-icon>
                      </button>
                    }
                  </mat-form-field>

                  @if (getSecondaryLabelFilterControl(field.name).value?.length && getAvailableOptions(getFilteredPairedOptions(field.subFieldConf || [], getSecondaryLabelFilterControl(field.name).value), getSelectionValue(getControl(group, field.name))).length > 0) {
                    <button mat-stroked-button color="primary" class="mb-2"
                      (click)="addAllFilteredSelections(getControl(group, field.name), undefined, field.subFieldConf || [], getSecondaryLabelFilterControl(field.name).value)">
                      <mat-icon>playlist_add</mat-icon>
                      {{ 'add_all_filtered' | transloco }}
                    </button>
                  }
                }

                @if (getSelectionValue(getControl(group, field.name)).length > 0) {
                  <button mat-stroked-button color="warn" class="mb-2"
                    (click)="removeAllSelections(getControl(group, field.name))">
                    <mat-icon>delete_sweep</mat-icon>
                    {{ 'remove_all' | transloco }}
                  </button>
                }

                <ng-container *ngTemplateOutlet="pairedSelectionTree; context: {
                  $implicit: getFilteredPairedOptions(field.subFieldConf || [], getSecondaryLabelFilterControl(field.name).value), 
                  value: getSelectionValue(getControl(group, field.name)), 
                  control: getControl(group, field.name) 
                }"></ng-container>
              </div>
            }

            @case (dataTypes.Selection) {
              <div class="selection-section" [formGroup]="group">
                <h4 class="mb-2">{{ field.label || field.name | transloco }}</h4>

                <ng-container *ngTemplateOutlet="selectionTree; context: { 
                  $implicit: field.subFieldConf, 
                  value: getSelectionValue(getControl(group, field.name)), 
                  control: getControl(group, field.name) 
                }"></ng-container>
              </div>
            }

            @case (dataTypes.String) {
              <mat-form-field appearance="outline">
                <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                <input matInput type="text" [formControlName]="field.name" />
              </mat-form-field>
            }

            @case (dataTypes.Int) {
              <mat-form-field appearance="outline">
                <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                <input matInput type="number" [formControlName]="field.name" />
              </mat-form-field>
            }

            @case (dataTypes.Float) {
              <mat-form-field appearance="outline">
                <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                <input matInput type="number" step="any" [formControlName]="field.name" />
              </mat-form-field>
            }

            @case (dataTypes.UnsignedIntStepper) {
              <mat-form-field appearance="outline">
                <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                <input matInput type="number" min="0" [formControlName]="field.name" />
              </mat-form-field>
            }

            @case (dataTypes.CheckBox) {
              <div class="checkbox-container">
                <mat-slide-toggle [formControlName]="field.name">
                  {{ field.label || field.name | transloco }}
                </mat-slide-toggle>
              </div>
            }

            @case (dataTypes.SingleSelection) {
              <mat-form-field appearance="outline">
                <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                <mat-select [formControlName]="field.name">
                  <mat-option [value]="null">--</mat-option>
                  @for (option of field.subFieldConf; track option) {
                    <mat-option [value]="option.name">
                      {{ option.label || option.name | transloco }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

              @case (dataTypes.Competence) {
                  <div class="competence-picker-container">

                      <mat-form-field appearance="outline" class="full-width mb-2">
                          <mat-label>{{ 'Filter nach Fach' | transloco }}</mat-label>
                          <mat-select [formControl]="subjectFilterControl">
                              <mat-option [value]="null">-- {{ 'Alle Fächer' | transloco }} --</mat-option>
                              @for (subject of subjects$ | async; track subject.id) {
                                  <mat-option [value]="subject.id">{{ subject.name }}</mat-option>
                              }
                          </mat-select>
                          @if (subjectFilterControl.value) {
                              <button matSuffix mat-icon-button (click)="$event.stopPropagation(); subjectFilterControl.setValue(null)">
                                  <mat-icon>close</mat-icon>
                              </button>
                          }
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="full-width">
                          <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                          <mat-select [formControlName]="field.name">
                              <mat-option [value]="null">--</mat-option>
                              @for (item of competences$ | async; track item.entity.id) {
                                  <mat-option [value]="item.entity.id">
                                    <span [style.padding-left.px]="(item.level - 1) * 20">
                                      @if (item.level > 1) { ↳ }
                                        {{ item.entity.name | transloco }}
                                    </span>
                                  </mat-option>
                              }
                          </mat-select>
                          @if (getControl(group, field.name).value; as selectedId) {
                              <mat-hint>ID: {{ selectedId }}</mat-hint>
                          }
                      </mat-form-field>

                  </div>
              }

            @case (dataTypes.ColorPicker) {
              <div class="color-picker-container">
                <mat-form-field appearance="outline">
                  <mat-label>{{ field.label || field.name | transloco }}</mat-label>
                  <input matInput type="text" [formControlName]="field.name" placeholder="#000000" />
                </mat-form-field>
                <input type="color" class="color-input" [value]="getControl(group, field.name).value || '#000000'" (input)="getControl(group, field.name).setValue($any($event.target).value); getControl(group, field.name).markAsDirty()" />
              </div>
            }

            @default {
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ field.label || field.name | transloco }}
                    </mat-panel-title>
                    <mat-panel-description>
                      <small>Fallback Editor ({{ field.datatype }})</small>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>JSON Value</mat-label>
                    <textarea matInput rows="5" [ngModel]="toJson(group.get(field.name)?.value)" (ngModelChange)="fromJson(group, field.name, $event)" [ngModelOptions]="{standalone: true}"></textarea>
                  </mat-form-field>
                </mat-expansion-panel>
              </mat-accordion>
            }
          }
        </div>
    </ng-template>
  }
</div>